import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query/src/types'
import type { SessionInfo } from 'server/generic/next-auth/auth-options'

export const useFreshSession = (): UseQueryResult<SessionInfo | undefined, Error> =>
    useQuery({
        queryKey: ['fresh-session'],
        queryFn: async () => {
            const response = await fetch('/api/auth/session')
            const result = await response.json()
            if (Object.keys(result).length === 0) {
                return undefined
            }
            return result
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    })
